export default __webpack_public_path__ + "static/sz_hu_2-715f534a65e186acfb9a69eae528ee2f.mp4";